module.exports = __webpack_public_path__ + "img/cart1.8355c0e4.png";